export const initialState = {
    totalValueQuestionnaire: '',
    typeValoration: '',
    data: {},
    activeValoration: false,
    disabledValors: true
  };
  
  const ValorationAplicationReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_VALORATE_APLICATION":
        return {
          ...state,
          totalValueQuestionnaire: action.totalValueQuestionnaire,
          typeValoration: action.typeValoration,
          data: action.data,
          activeValoration: action.activeValoration,
          disabledValors: action.disabledValors,

        };
      default:
        return state;
    }
  };
  
  export default ValorationAplicationReducer;
  